import { __awaiter, __generator } from "tslib";
import * as React from 'react';
import cx from 'classnames';
import { useState, useRef, useEffect } from 'react';
import s from './ApplyOffer.scss';
import { Toggler } from './Toggler/Toggler';
import { OfferForm } from './OfferForm/OfferForm';
export var DataHook;
(function (DataHook) {
    DataHook["Root"] = "ApplyOffer.Root";
    DataHook["TogllerLabel"] = "Togller.Label";
    DataHook["TogllerCheckbox"] = "checkbox-wrapper";
    DataHook["TogllerTitle"] = "Togller.Title";
    DataHook["OfferFormNoAnimationCollapse"] = "OfferForm.NoAnimationCollapse";
    DataHook["OfferInputSectionInput"] = "OfferInputSection.Input";
    DataHook["OfferInputSectionButton"] = "OfferInputSection.Button";
    DataHook["OfferInputSectionError"] = "OfferInputSection.Error";
    DataHook["OfferInputApplyOfferStatusMessage"] = "OfferInputSection.ApplyOfferStatusMessage";
})(DataHook || (DataHook = {}));
export var ErrorViewType;
(function (ErrorViewType) {
    ErrorViewType["TOOLTIP"] = "Tooltip";
    ErrorViewType["BOX_ABOVE"] = "BoxAbove";
    ErrorViewType["BOX_BELOW"] = "BoxBelow";
})(ErrorViewType || (ErrorViewType = {}));
export var ApplyOffer = function (props) {
    var className = props.className, stylableClasses = props.stylableClasses, isCollapsible = props.isCollapsible, isInputInitiallyShown = props.isInputInitiallyShown, isApplied = props.isApplied, successMessage = props.successMessage, errorMessage = props.errorMessage, errorViewType = props.errorViewType, value = props.value, toggleInput = props.toggleInput, toggler = props.toggler, onToggle = props.onToggle, labelId = props.labelId, isRTL = props.isRTL, shouldAnimate = props.shouldAnimate, fullWidthApplyButton = props.fullWidthApplyButton, placeholder = props.placeholder, applyButtonText = props.applyButtonText, removeButtonText = props.removeButtonText;
    var classNames = cx(s.applyOffer, className);
    var initialIsInputShown = !isCollapsible || isInputInitiallyShown || isApplied || !!errorMessage;
    var _a = useState(value || ''), offerValue = _a[0], setOfferValue = _a[1];
    var _b = useState(initialIsInputShown), isInputShown = _b[0], setIsInputShown = _b[1];
    var _c = useState(false), isDirty = _c[0], setIsDirty = _c[1];
    var textFieldRef = useRef(null);
    useEffect(function () {
        var _a;
        var isAlwaysOpen = !isCollapsible;
        (_a = textFieldRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        setIsInputShown(isAlwaysOpen || isInputInitiallyShown || isApplied || !!errorMessage || toggleInput);
    }, [isCollapsible, isInputInitiallyShown, isApplied, errorMessage, toggleInput]);
    useEffect(function () {
        setIsDirty(false);
    }, [isApplied, errorMessage]);
    var toggleInputVisibility = function () { return __awaiter(void 0, void 0, void 0, function () {
        var updatedIsInputShown;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    updatedIsInputShown = !isInputShown;
                    setIsInputShown(updatedIsInputShown);
                    onToggle === null || onToggle === void 0 ? void 0 : onToggle(updatedIsInputShown);
                    if (!(!updatedIsInputShown && isApplied)) return [3 /*break*/, 2];
                    return [4 /*yield*/, clearInput()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var handleKeyPress = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(isInputShown && !isApplied && event.key === 'Enter')) return [3 /*break*/, 2];
                    return [4 /*yield*/, handleApply(event)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var handleApply = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var onApply;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    onApply = props.onApply;
                    event.stopPropagation();
                    event.preventDefault();
                    return [4 /*yield*/, onApply(offerValue)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleSubmit = function (e) {
        return isApplied ? handleInputClear(e) : handleApply(e);
    };
    var handleInputClear = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    return [4 /*yield*/, clearInput()];
                case 1:
                    _a.sent();
                    setIsDirty(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var clearInput = function () { return __awaiter(void 0, void 0, void 0, function () {
        var onClear;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    onClear = props.onClear;
                    setOfferValue('');
                    return [4 /*yield*/, onClear()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var onChangeInput = function (newValue) {
        setOfferValue(newValue);
        setIsDirty(true);
    };
    return (React.createElement("div", { className: classNames, "data-hook": DataHook.Root, role: 'textbox', tabIndex: 0, onKeyPress: function (e) { return handleKeyPress(e); } },
        React.createElement(Toggler, { isCollapsible: isCollapsible, toggler: toggler, labelId: labelId, isInputShown: isInputShown, toggleInputVisibility: toggleInputVisibility }),
        React.createElement(OfferForm, { isRTL: isRTL, shouldAnimate: shouldAnimate, stylableClasses: stylableClasses, isInputShown: isInputShown, isApplied: isApplied, isDirty: isDirty, value: offerValue, successMessage: successMessage, errorMessage: errorMessage, errorViewType: errorViewType, fullWidthApplyButton: fullWidthApplyButton, textFieldRef: textFieldRef, labelId: labelId, placeholder: placeholder, applyButtonText: applyButtonText, removeButtonText: removeButtonText, onSubmit: handleSubmit, onInputChanged: onChangeInput })));
};
//# sourceMappingURL=ApplyOffer.js.map